module.exports = __webpack_public_path__ + "img/physical-activity-sidebar.f80ea2f7.svg";